import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { DateTime } from 'luxon';
import * as actions from '../../../store/actions';

// local imports
import api from '../../../store/api';
import {
	toggleGlobalLoader,
	addErrorAlert,
	addSuccessAlert,
} from '../../../store/calls/alertLoadingDispatch';
import AdminWrapper from '../../theme/wrappers/AdminWrapper';
import validators from '../../../utils/forms/validators';
import formatters from '../../../utils/forms/formatters';
import PaginatedTable from '../../theme/tables/PaginatedTable';
import ConfirmModal from '../../theme/modals/ConfirmModal';
import FormModal from '../../theme/modals/FormModal';
import SearchAndSelectModal from '../../theme/modals/SearchAndSelectModal';
import * as preconfiguredInputs from '../../../utils/forms/preconfiguredInputs';

import { displaySummaryData } from '../../../utils/displayData';
import AlertCard from '../../theme/cards/AlertCard';
import { getUUID } from '../../../utils/hashFuncs';

/*

NOTE TO SELF:

TOP IS A CARD, NAME OF PROGRAM AND SPECIFICATIONS, ALLOWS YOU TO EDIT.
BELOW IS A TABLE. SAME TABLE AS THE OTHER ONES, WHICH ALLOWS YOU TO EDIT.

I ALSO NEED TO BUILD A SEARCH FUNCTION THAT WILL ALLOW YOU TO ADD OR REMOVE DISTRICTS OR IMPROVEMENTS TO THIS.

 */
class ResidentialSpecScreen extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			displayedData: [],
			displayedColumns: [],
			dataPullLimit: 25,
			dataPullOffset: 0,
			mode: 'loan_products',

			districtAdditionSearchResults: [],
			usersAdditionSearchResults: [],

			specInstance: {}, // the actual pace program thing that is the focus of the spec page. Pulled by ID from URL.

			// edit and delete
			editModalOpen: false,
			deleteModalOpen: false,

			loanProductCreateModalOpen: false,
			loanProductDeleteModalOpen: false,

			applicationTemplateCreateModalOpen: false,
			applicationTemplateDeleteModalOpen: false,
			applicationTemplateDuplicateModalOpen: false,
			applicationTemplateDuplicateId: 0,

			userCreateModalOpen: false,
			userUpdateModalOpen: false,
			// duplicate
			loanProductDuplicateModalOpen: false,
			loanProductDuplicateId: 0,
		};

		this.specInstanceId = props.match.params.id;

		this.baseAPIPath = '/funders-residential/' + this.specInstanceId + '/';

		this.billingStartTypes = [
			{
				value: 'month_after_proj_complete',
				display: 'Month after project is completed',
			},
			{
				value: 'next_prop_tax_date',
				display: 'The next property tax billing date',
			},
			{
				value: 'next_fiscal_year',
				display: "The start of the next fiscal year for the project's county",
			},
			{ value: 'another_date', display: 'Annually on a specific Date' },
		];

		this.editSpecInstanceInputs = [
			{
				type: 'text',
				label: 'Name',
				subLabel:
					'Your Funder name is only visible to you and, for your PACE products, to Administrators of programs you have elected to compete in.',
				dataKey: 'name',
				...validators.isStringOfMinLength(2),
			},
			{
				type: 'textarea',
				label: 'Description',
				dataKey: 'description',
			},
		];

		this.createLoanProductInputs = [
			{
				label: 'Loan Product Type',
				dataKey: 'type',
				...preconfiguredInputs.loanResidentialProductTypeSelect,
				...validators.exists,
			},
			{
				type: 'text',
				label: 'Name',
				dataKey: 'name',
				...validators.isStringOfMinLength(2),
			},
			{
				type: 'textarea',
				label: 'Description',
				dataKey: 'description',
			},
			{
				type: 'text',
				label: 'Minimum Deal Size',
				dataKey: 'minimum_size',
				...validators.isNumberWhenStripped,
				...formatters.USDCurrency,
			},
			{
				type: 'text',
				label: 'Maximum Deal Size (if applicable)',
				dataKey: 'maximum_size',
				...validators.isNumberWhenStripped,
				...formatters.USDCurrency,
			},
			{
				type: 'text',
				label: 'Prepayment Penalty',
				dataKey: 'pre_payment_penalty',
			},
			// {
			//     type: 'text',
			//     label: "Max Loan to Value (as %)",
			//     dataKey: "max_loan_to_val_percent_req",
			//     ...validators.isNumberWhenStripped,
			//     ...formatters.percentage,
			// },
			// {
			//     type: 'text',
			//     label: "Max Post-Money Total LTV Accepted (as %)",
			//     subLabel: "How much clear equity needs to be left on the property after the PACE loan",
			//     dataKey: "post_pace_clear_equity_percent_req",
			//     ...validators.isNumberWhenStripped,
			//     ...formatters.percentage,
			// },
		];

		this.editUserInstanceInputs = [
			{
				type: 'text',
				label: 'ID',
				dataKey: 'id',
				readOnly: true,
			},
			{
				type: 'text',
				label: 'Name',
				dataKey: 'name',
				readOnly: true,
			},
			{
				type: 'text',
				label: 'Email',
				dataKey: 'email',
				readOnly: true,
			},
			{
				type: 'text',
				label: 'Title',
				dataKey: 'title',
			},
		];

		this.duplicateLoanProductInputs = [
			{
				type: 'text',
				label: 'Name',
				dataKey: 'name',
				...validators.isStringOfMinLength(2),
				...validators.isStringOfMaxLength(255),
			},
		];

		this.createApplicationTemplateInputs = [
			{
				type: 'text',
				label: 'Name',
				dataKey: 'name',
				...validators.isStringOfMinLength(2),
				...validators.isStringOfMaxLength(255),
			},
		];

		this.duplicateApplicationTemplateInputs = [
			{
				type: 'text',
				label: 'Name',
				dataKey: 'name',
				...validators.isStringOfMinLength(2),
				...validators.isStringOfMaxLength(255),
			},
		];
	}

	componentDidMount() {
		toggleGlobalLoader(true);
		this.getData()
			// .then(() => this.changeMode('application_templates'))// 'loan_products'
			.finally(() => toggleGlobalLoader(false));
	}

	toggleEditModal = () => {
		this.setState({ editModalOpen: !this.state.editModalOpen });
	};

	getData = (xtraParams = {}) => {
		return api.get(this.baseAPIPath, { cb: getUUID() }).then((res) => {
			this.setState(
				{
					specInstance: { ...res.data },
				},
				() => this.changeMode(this.state.mode)
			);
		});
	};

	populateSpecInstanceInputsWithValues = () => {
		return this.editSpecInstanceInputs.map((d) => ({
			...d,
			value: this.state.specInstance[d.dataKey],
		}));
	};

	handleDeleteRequest = () => {
		api
			.patch(this.baseAPIPath, { is_active: 0 })
			.then(() => (window.location = '/admin/funders-residential/'));
	};

	handleUpdateRequest = (data) => {
		api
			.patch(this.baseAPIPath, data)
			.then(this.getData)
			.catch((err) => {
				console.error(err);
				addErrorAlert('The update failed. ');
			})
			.finally(() =>
				this.setState({ editModalOpen: false, editingInstance: null })
			);
	};

	handleSearch = (val) => {
		this.setState({ nameFilter: val }, this.getData);
	};

	handleLoanProductCreateRequest = (data) => {
		return api
			.post('/loan-products/', { ...data, funder: this.specInstanceId })
			.then((res) => {
				this.setState({ loanProductCreateModalOpen: false });
				this.props.updateNavInstructions({
					...this.props.navInstructions,
					createAttribute: true,
				});
				this.props.history.push({
					pathname: this.props.location.pathname + '/product/' + res.data.id,
				});
			});
	};

	handleUserUpdateRequest = (data) => {
		const { email, name, ...filteredData } = data;

		api
			.patch('/user-funders/' + data.id + '/', filteredData)
			.then(this.getData)
			.catch((err) => {
				console.error(err);
				addErrorAlert('The Funder User update failed. ');
			})
			.finally(() =>
				this.setState({ userUpdateModalOpen: false, editingInstance: null })
			);
	};

	handleLoanProductDeleteOrHideRequest = (
		loanproduct_id,
		action = 'delete'
	) => {
		let request;
		if (action === 'delete') {
			request = { is_active: 0 };
		} else if (action === 'show') {
			request = { is_displayable: 1 };
		} else {
			request = { is_displayable: 0 };
		}
		toggleGlobalLoader(true);
		return api
			.patch(`/loan-products/${loanproduct_id}/`, request)
			.then((res) => {
				this.setState({
					editingInstance: null,
					loanProductDeleteModalOpen: false,
				});
				this.getData();
			})
			.finally(() => toggleGlobalLoader(false));
	};

	handleDistrictFunderCreateRequest = (district_id) => {
		return api
			.post('/district-funders/', {
				district: district_id,
				funder: this.state.specInstance.id,
			})
			.then(() => this.getData().then(() => this.changeMode('areas')))
			.catch(() => addErrorAlert('There was a problem adding that area.'));
	};

	handleDistrictFunderDeleteRequest = (districtfunder_id) => {
		return api
			.delete(`/district-funders/${districtfunder_id}/`)
			.then(() => this.getData().then(() => this.changeMode('areas')))
			.catch(() => addErrorAlert('There was a problem deleting that area.'));
	};

	handleUserFunderCreateRequest = (user_id) => {
		return api
			.post('/user-funders/', {
				user: user_id,
				funder: this.state.specInstance.id,
			})
			.then(() => this.getData().then(() => this.changeMode('funder_users')))
			.catch(() => addErrorAlert('There was a problem adding this user.'));
	};

	handleUserFunderDeleteRequest = (userfunder_id) => {
		return api
			.delete(`/user-funders/${userfunder_id}/`)
			.then(() => this.getData().then(() => this.changeMode('funder_users')))
			.catch(() => addErrorAlert('There was a problem deleting this user.'));
	};

	handleApplicationTemplateCreateRequest = (data) => {
		return api
			.post('/application-templates/', {
				name: data.name,
				template: data.template,
				funder: this.state.specInstance.id,
			})
			.then((res) =>
				this.props.history.push(`/admin/app-template/${res.data.id}/`)
			)
			.catch(() =>
				addErrorAlert('There was an error creating the new template')
			);
	};

	handleApplicationTemplateDuplicateRequest = (data) => {
		return api
			.post('/application-templates/', {
				duplicate_id: this.state.editingInstance.id,
				name: data.name,
				funder: this.state.specInstance.id,
			})
			.then((res) =>
				this.props.history.push(`/admin/app-template/${res.data.id}/`)
			)
			.catch(() =>
				addErrorAlert('There was an error creating the duplicate template.')
			);
	};

	handleApplicationTemplateDeleteRequest = (application_template_id) => {
		return api
			.delete(`/application-templates/${application_template_id}/`)
			.then(() =>
				this.getData().then(() => this.changeMode('application_templates'))
			)
			.catch(() =>
				addErrorAlert(
					'There was an error deleting that template. ' +
						'You must remove the template from all associated loan products before deleting it.'
				)
			);
	};

	changeMode = (mode) => {
		let displayedData;
		if (mode === 'loan_products') {
			displayedData = (this.state.specInstance?.loan_products || [])
				.filter((d) => d.is_active != false)
				.map((d) => ({
					...d,
					_html_name: (
						<a
							className="has-text-primary"
							href={`${window.location}/product/${d.id}`}
						>
							{d.name}
						</a>
					),
				}));
		}

		if (mode === 'areas') {
			displayedData = (this.state.specInstance?.districts || []).map((d) => ({
				...d,
				...(d?.district || {}),
			}));
		}

		if (mode === 'application_templates') {
			displayedData = (
				this.state.specInstance?.application_templates || []
			).map((d) => ({
				...d,
				_html_created: DateTime.fromISO(d.created).toLocaleString(
					DateTime.DATE_SHORT
				),
			}));
		}

		if (mode === 'funder_users') {
			displayedData = (this.state.specInstance?.funder_users || []).map(
				(d) => ({
					name: `${d.users?.first_name || ''} ${d.users?.last_name || ''}`,
					email: d.users?.email,
					title: d.title,
					role: d.users?.profile?.role,
					id: d.id,
					funder_id: d.funder_id,
					user_id: d.user_id,
				})
			);
		}

		this.setState({ mode, displayedData });
	};

	getDistrictsForAddition = (searchParam) => {
		let params = { limit: 100, name: searchParam };

		return api
			.get('/districts/', params)
			.then((res) => {
				this.setState({
					districtAdditionSearchResults: res.data.results.map((d) => ({
						...d,
						// added: this.state.displayedData.filter(d => d.district).map(d => d.district.id).includes(d.id)
					})),
				});
			})
			.catch(() => addErrorAlert('Failed to pull all districts.'));
	};

	getUsersForAddition = (searchParam) => {
		let params = { limit: 100, searchVal: searchParam };

		return api
			.get('/users/', params)
			.then((res) => {
				this.setState({
					usersAdditionSearchResults: res.data.results.map((d) => ({
						...d,
						// added: this.state.displayedData.filter(d => d.district).map(d => d.district.id).includes(d.id)
					})),
				});
			})
			.catch(() => addErrorAlert('Failed to pull all users.'));
	};

	handleOpenDuplicateModal = (data) => {
		this.populateDuplicateInputs(data.name);
		this.setState({
			loanProductDuplicateId: data.id,
			loanProductDuplicateModalOpen: true,
		});
	};

	populateDuplicateInputs = (name) => {
		this.duplicateLoanProductInputs = this.duplicateLoanProductInputs.map(
			(d) => ({
				...d,
				value: 'Copy of ' + name,
			})
		);
	};

	duplicateLoanProduct = (data) => {
		let id = this.state.loanProductDuplicateId;
		let { name } = data;
		toggleGlobalLoader(true);
		api
			.get('/dupe-loan-product/', {
				loan_product_id: id,
				loan_product_name: name,
			})
			.then(() => {
				addSuccessAlert('Duplication Succeeded');
				this.handleCloseDuplicateModal();
				setTimeout(() => {
					this.getData().then(toggleGlobalLoader(false));
				}, 1000);
			})
			.catch(() => {
				addErrorAlert('Duplication failed');
			});
	};

	handleCloseDuplicateModal = () => {
		this.setState({ loanProductDuplicateModalOpen: false });
	};

	renderDistrictSearchAndSelectElement = (result) => {
		let df =
			this.state.specInstance.districts.find(
				(d) => d.district.id === result.id
			) || {};
		let df_id = df.id;
		return (
			<div className="ss-result">
				<span
					className="icon"
					onClick={() => {
						if (df_id) {
							this.handleDistrictFunderDeleteRequest(df_id);
						} else {
							this.handleDistrictFunderCreateRequest(result.id);
						}
					}}
				>
					{df_id ? (
						<i className="fas fa-check-square has-text-success" />
					) : (
						<i className="far fa-square" />
					)}
				</span>
				<span className="has-text-weight-semibold">{result.name}</span>
				<span>{result.district_type}</span>
				<span>{result.state}</span>
			</div>
		);
	};

	renderUserSearchAndSelectElement = (result) => {
		let df =
			this.state.specInstance.funder_users.find(
				(d) => d.users.id === result.id
			) || {};
		let df_id = df.id;
		return (
			<div className="ss-result">
				<span
					className="icon"
					onClick={() => {
						if (df_id) {
							this.handleUserFunderDeleteRequest(df_id);
						} else {
							this.handleUserFunderCreateRequest(result.id);
						}
					}}
				>
					{df_id ? (
						<i className="fas fa-check-square has-text-success" />
					) : (
						<i className="far fa-square" />
					)}
				</span>
				<span className="has-text-weight-semibold">{result.name}</span>
				<span>{result.first_name}</span>
				<span>{result.last_name}</span>
				<span>{result.email}</span>
				<span>{result.profile.company}</span>
			</div>
		);
	};

	render() {
		let { specInstance } = this.state;
		return (
			<AdminWrapper>
				{/* card containing the details of the spec instance */}
				<div className="section">
					<div className="container is-fullhd mx-6">
						<div className="box">
							<div className="level" style={{ maxWidth: '90%' }}>
								<div className="level-left">
									<div className="level-item">
										<div>
											<h2 className="title is-2">{specInstance.name}</h2>
											<p className="has-text-grey-light mr-6">
												Your Funder name is only visible to you and, for PACE
												products, to Administrators of programs you have elected
												to compete in.
											</p>
										</div>
									</div>
								</div>

								<div className="level-left">
									<div className="level-item">
										<button
											className="button is-link"
											onClick={() => this.setState({ editModalOpen: true })}
										>
											<i className="fas fa-pencil" />
											Edit
										</button>
									</div>
									<div className="level-item">
										<button
											className="button is-danger"
											onClick={() => this.setState({ deleteModalOpen: true })}
										>
											Delete
										</button>
									</div>
									<div className="level-item">
										<Link to="/admin/funders-residential/">
											<button className="button is-primary">Back</button>
										</Link>
									</div>
								</div>
							</div>

							<p className="has-text-weight-bold">{specInstance.description}</p>

							{this.editSpecInstanceInputs
								.filter((d) => !['name', 'description'].includes(d.dataKey))
								.map((d) => {
									return (
										<p>
											<span className="mr-3">{d.label}:</span>
											<span>
												{displaySummaryData(specInstance[d.dataKey], d.dataKey)}
											</span>
										</p>
									);
								})}
						</div>
					</div>
				</div>

				<div className="section pt-2">
					<div className="container is-fullhd mx-6">
						<div className="tabs is-medium">
							<ul>
								<li
									className={
										this.state.mode === 'loan_products' ? 'is-active' : ''
									}
									onClick={() => this.changeMode('loan_products')}
								>
									<a>
										<span className="icon is-small">
											<i className="fas fa-money-check" aria-hidden="true" />
										</span>
										<span>Financing Products</span>
									</a>
								</li>
								<li
									className={this.state.mode === 'areas' ? 'is-active' : ''}
									onClick={() => this.changeMode('areas')}
								>
									<a>
										<span className="icon is-small">
											<i className="fas fa-map-pin" aria-hidden="true" />
										</span>
										<span>Areas of Operation</span>
									</a>
								</li>
								<li
									className={
										this.state.mode === 'application_templates'
											? 'is-active'
											: ''
									}
									onClick={() => this.changeMode('application_templates')}
								>
									<a>
										<span className="icon is-small">
											<i className="fas fa-file-contract" />
										</span>
										<span>Application Templates</span>
									</a>
								</li>
								<li
									className={
										this.state.mode === 'funder_users' ? 'is-active' : ''
									}
									onClick={() => this.changeMode('funder_users')}
								>
									<a>
										<span className="icon is-small">
											<i className="fas fa-users" />
										</span>
										<span>Contacts</span>
									</a>
								</li>
							</ul>
						</div>
						{this.state.mode === 'loan_products' && (
							<>
								<div className="level">
									<div className="level-left">
										<div className="level-item">
											<h4 className="title is-4">Manage Financing Products</h4>
										</div>
									</div>
									<div className="level-right">
										<div className="level-item">
											<button
												className="button is-link"
												onClick={() =>
													this.setState({ loanProductCreateModalOpen: true })
												}
											>
												+ Add Loan Product
											</button>
										</div>
									</div>
								</div>
								<PaginatedTable
									className="is-fullwidth is-hoverable"
									data={this.state.displayedData}
									columns={['name', 'description', 'other_notes']}
									pullLimit={this.state.dataPullLimit}
									handleLimitChange={this.handleLimitChange}
									pullOffset={this.state.dataPullOffset}
									handleOffsetChange={this.handleOffsetChange}
									showSortBar={false}
									showPageNavigators={false}
									actions={[
										{
											name: 'Duplicate',
											elem: (
												<span className="icon">
													<i className="fas fa-clone" />
												</span>
											),
											action: (data) => this.handleOpenDuplicateModal(data),
										},
										{
											name: 'Delete',
											elem: (
												<span className="icon has-text-danger">
													<i className="fas fa-minus-square" />
												</span>
											),
											action: (data) =>
												this.setState({
													loanProductDeleteModalOpen: true,
													editingInstance: { ...data },
												}),
										},
										{
											name: 'Display',
											elem: (data) => {
												if (data.is_displayable) {
													return (
														<div className="cursor-is-pointer">
															<i className="fas fa-check-square has-text-link mr-2" />
															<span>Active</span>
														</div>
													);
												}
												return (
													<div className="has-text-grey cursor-is-pointer">
														<i className="far fa-square mr-2" />
														<span>Hidden</span>
													</div>
												);
											},
											action: (data) => {
												if (data.is_displayable) {
													this.handleLoanProductDeleteOrHideRequest(
														data.id,
														'hide'
													);
												} else {
													this.handleLoanProductDeleteOrHideRequest(
														data.id,
														'show'
													);
												}
											},
										},
									]}
								/>
							</>
						)}

						{this.state.mode === 'areas' && (
							<>
								<div className="level">
									<div className="level-left">
										<div className="level-item">
											<h4 className="title is-4">Manage Areas of Operation</h4>
										</div>
									</div>
									<div className="level-right">
										<div className="level-item">
											<button
												className="button is-link"
												onClick={() =>
													this.setState({
														addDistrictPaceProgramModalOpen: true,
													})
												}
											>
												+ Add a State, County, or City
											</button>
										</div>
										{/* <div className={'level-item'}> */}
										{/*    <button */}
										{/*        className='button is-info' */}
										{/*        onClick={this.loadAndOpenMap} */}
										{/*    > */}
										{/*        <i className="far fa-map mr-2"/> */}
										{/*        View Map */}
										{/*    </button> */}
										{/* </div> */}
									</div>
								</div>
								<AlertCard
									type="info"
									msg={
										"If you don't select any areas of operation, your loan products default to being available nationally."
									}
									className="mb-4"
								/>
								<PaginatedTable
									className="is-fullwidth is-hoverable"
									data={this.state.displayedData}
									columns={['name', 'type', 'state']}
									pullLimit={this.state.dataPullLimit}
									handleLimitChange={this.handleLimitChange}
									pullOffset={this.state.dataPullOffset}
									handleOffsetChange={this.handleOffsetChange}
									showSortBar={false}
									showPageNavigators={false}
									actions={[
										{
											name: 'Delete',
											elem: (
												<span className="icon has-text-danger">
													<i className="fas fa-minus-square" />
												</span>
											),
											action: (data) => {
												let df_id = (
													this.state.specInstance.districts.find(
														(d) => d.district.id === data.id
													) || {}
												).id;
												return this.handleDistrictFunderDeleteRequest(df_id);
											},
										},
									]}
								/>
							</>
						)}

						{this.state.mode === 'application_templates' && (
							<>
								<div className="level">
									<div className="level-left">
										<div className="level-item">
											<h4 className="title is-4">
												Manage Application Templates
											</h4>
										</div>
									</div>
									<div className="level-right">
										<div className="level-item">
											<button
												className="button is-link"
												onClick={() =>
													this.setState({
														applicationTemplateCreateModalOpen: true,
													})
												}
											>
												+ Add Template
											</button>
										</div>
									</div>
								</div>

								<PaginatedTable
									className="is-fullwidth is-hoverable"
									data={this.state.displayedData}
									columns={['name', 'created']}
									pullLimit={this.state.dataPullLimit}
									handleLimitChange={this.handleLimitChange}
									pullOffset={this.state.dataPullOffset}
									handleOffsetChange={this.handleOffsetChange}
									showSortBar={false}
									showPageNavigators={false}
									actions={[
										{
											name: 'Duplicate',
											elem: (
												<span className="icon">
													<i className="fas fa-clone" />
												</span>
											),
											action: (data) =>
												this.setState({
													applicationTemplateDuplicateModalOpen: true,
													editingInstance: data,
												}),
										},
										{
											name: 'Edit',
											elem: (
												<span className="icon">
													<i className="fas fa-edit" />
												</span>
											),
											action: (data) => {
												window
													.open(`/admin/app-template/${data.id}/`, '_blank')
													.focus();
											},
										},
										{
											name: 'Delete',
											elem: (
												<span className="icon has-text-danger">
													<i className="fas fa-minus-square" />
												</span>
											),
											action: (data) =>
												this.setState({
													applicationTemplateDeleteModalOpen: true,
													editingInstance: { ...data },
												}),
										},
									]}
								/>
							</>
						)}

						{this.state.mode === 'funder_users' && (
							<>
								<div className="level">
									<div className="level-left">
										<div className="level-item">
											<h4 className="title is-4">Manage Contacts</h4>
										</div>
									</div>
									<div className="level-right">
										<div className="level-item">
											<button
												className="button is-link"
												onClick={() =>
													this.setState({
														userCreateModalOpen: true,
													})
												}
											>
												+ Add Contact
											</button>
										</div>
									</div>
								</div>
								<AlertCard
									type="info"
									msg="This is to associate CleanFi users with a funder. If the user does not exist, you need to create one."
									className="mb-4"
								/>
								<PaginatedTable
									className="is-fullwidth is-hoverable"
									data={this.state.displayedData}
									columns={['name', 'email', 'title', 'role']}
									pullLimit={this.state.dataPullLimit}
									handleLimitChange={this.handleLimitChange}
									pullOffset={this.state.dataPullOffset}
									handleOffsetChange={this.handleOffsetChange}
									showSortBar={false}
									showPageNavigators={false}
									actions={[
										{
											name: 'Edit',
											elem: (
												<span className="icon has-text-primary">
													<i className="fas fa-edit" />
												</span>
											),
											action: (data) =>
												this.setState({
													userUpdateModalOpen: true,
													editingInstance: { ...data },
												}),
										},
										{
											name: 'Delete',
											elem: (
												<span className="icon has-text-danger">
													<i className="fas fa-minus-square" />
												</span>
											),
											action: (data) =>
												this.setState({
													userDeleteModalOpen: true,
													editingInstance: { ...data },
												}),
										},
									]}
								/>
							</>
						)}
					</div>
				</div>

				<FormModal
					title={'Edit ' + this.state.specInstance.name}
					visible={this.state.editModalOpen}
					inputs={this.populateSpecInstanceInputsWithValues()}
					disableAutocomplete
					onSubmit={this.handleUpdateRequest}
					onCancel={() =>
						this.setState({ editModalOpen: false, editingInstance: null })
					}
				/>

				<FormModal
					title="Create a new loan product"
					visible={this.state.loanProductCreateModalOpen}
					inputs={this.createLoanProductInputs}
					disableAutocomplete
					onSubmit={this.handleLoanProductCreateRequest}
					onCancel={() => this.setState({ loanProductCreateModalOpen: false })}
				/>
				<FormModal
					title="Update Contact"
					visible={this.state.userUpdateModalOpen}
					inputs={this.editUserInstanceInputs.map((input) => ({
						...input,
						value: this.state.editingInstance?.[input.dataKey] || '',
					}))}
					disableAutocomplete
					onSubmit={this.handleUserUpdateRequest}
					onCancel={() => this.setState({ userUpdateModalOpen: false })}
				/>

				<ConfirmModal
					type="warning"
					visible={this.state.deleteModalOpen}
					prompt={
						!!this.state.specInstance &&
						`Are you sure you want to deactivate ${this.state.specInstance.name}?`
					}
					onCancel={() =>
						this.setState({ deleteModalOpen: false, editingInstance: null })
					}
					onAccept={this.handleDeleteRequest}
				/>

				{/* Delete pace program district */}
				<ConfirmModal
					type="warning"
					visible={this.state.loanProductDeleteModalOpen}
					prompt={
						!!this.state.editingInstance &&
						`Are you sure you want to remove the product ${this.state.editingInstance.name} from this funder?`
					}
					onCancel={() =>
						this.setState({
							loanProductDeleteModalOpen: false,
							editingInstance: null,
						})
					}
					onAccept={() =>
						this.handleLoanProductDeleteOrHideRequest(
							this.state.editingInstance.id,
							'delete'
						)
					}
				/>

				<SearchAndSelectModal
					title={`Add Communities to ${this.state.specInstance.name}`}
					visible={this.state.addDistrictPaceProgramModalOpen}
					onCancel={() =>
						this.setState({ addDistrictPaceProgramModalOpen: false })
					}
					handleSearch={(val) => {
						if (val.length > 2) {
							this.getDistrictsForAddition(val);
						}
					}}
					results={this.state.districtAdditionSearchResults}
					renderResultElement={this.renderDistrictSearchAndSelectElement}
				/>

				<FormModal
					title="Duplicate a loan product"
					visible={this.state.loanProductDuplicateModalOpen}
					inputs={this.duplicateLoanProductInputs}
					onSubmit={this.duplicateLoanProduct}
					onCancel={this.handleCloseDuplicateModal}
				/>

				{this.state.applicationTemplateCreateModalOpen && (
					<FormModal
						title="Create a new Application Template"
						visible
						inputs={this.createApplicationTemplateInputs}
						onSubmit={this.handleApplicationTemplateCreateRequest}
						onCancel={() => {
							this.setState({ applicationTemplateCreateModalOpen: false });
						}}
					/>
				)}
				<SearchAndSelectModal
					title={`Add a new contact to ${this.state.specInstance.name}`}
					visible={this.state.userCreateModalOpen}
					onCancel={() => this.setState({ userCreateModalOpen: false })}
					handleSearch={(val) => {
						if (val && val.length > 2) {
							this.getUsersForAddition(val);
						}
					}}
					results={this.state.usersAdditionSearchResults}
					renderResultElement={this.renderUserSearchAndSelectElement}
				/>
				{this.state.applicationTemplateDuplicateModalOpen && (
					<FormModal
						title="Duplicate Template"
						visible
						inputs={this.duplicateApplicationTemplateInputs.map((d) => {
							if (d.dataKey === 'name') {
								return {
									...d,
									value: this.state.editingInstance.name + ' [COPY]',
								};
							}
							return d;
						})}
						onSubmit={(data) => {
							return this.handleApplicationTemplateDuplicateRequest(data).then(
								() => [
									this.setState({
										applicationTemplateDuplicateModalOpen: false,
										editingInstance: null,
									}),
								]
							);
						}}
						onCancel={() => {
							this.setState({
								applicationTemplateDuplicateModalOpen: false,
								editingInstance: null,
							});
						}}
					/>
				)}
				{this.state.applicationTemplateDeleteModalOpen && (
					<ConfirmModal
						type="warning"
						visible
						prompt={
							!!this.state.editingInstance &&
							`Are you sure you want to delete the template ${this.state.editingInstance.name}?`
						}
						onCancel={() =>
							this.setState({
								applicationTemplateDeleteModalOpen: false,
								editingInstance: null,
							})
						}
						onAccept={() => {
							return this.handleApplicationTemplateDeleteRequest(
								this.state.editingInstance.id
							).then(() => {
								this.setState({
									applicationTemplateDeleteModalOpen: false,
									editingInstance: null,
								});
							});
						}}
					/>
				)}
				{this.state.userDeleteModalOpen && (
					<ConfirmModal
						type="warning"
						visible
						prompt={
							!!this.state.editingInstance &&
							`Are you sure you want to remove the contact ${this.state.editingInstance.name}?`
						}
						onCancel={() =>
							this.setState({
								userDeleteModalOpen: false,
								editingInstance: null,
							})
						}
						onAccept={() => {
							const df_id = (
								this.state.specInstance.funder_users.find(
									(d) => d.id === this.state.editingInstance.id
								) || {}
							).id;

							return this.handleUserFunderDeleteRequest(df_id).then(() => {
								this.setState({
									userDeleteModalOpen: false,
									editingInstance: null,
								});
							});
						}}
					/>
				)}
			</AdminWrapper>
		);
	}
}

const mapStateToProps = (state) => ({
	navInstructions: state.session.navInstructions,
});

const mapDispatchToProps = (dispatch) => ({
	updateNavInstructions: (data) =>
		dispatch(actions.session.updateNavInstructions(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResidentialSpecScreen);
